/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["section.testimonios{background-color:#f2f7fa;padding:2rem}section.testimonios .card{transition:transform .2s ease;border-radius:25px;min-height:200px;height:250px}section.testimonios .card:hover{transform:translateY(-4px)}section.testimonios h2{font-size:2rem;color:#2355af}section.testimonios h5{font-size:1.2rem;color:#2355af}section.testimonios p{font-size:1rem}@media (max-width:767px){section.testimonios h2{font-size:1.5rem}}"];
export { styles as styles };
